import { render } from "./ReportCaricamenti.vue?vue&type=template&id=972abc52&scoped=true"
import script from "./ReportCaricamenti.vue?vue&type=script&lang=js"
export * from "./ReportCaricamenti.vue?vue&type=script&lang=js"

import "./ReportCaricamenti.vue?vue&type=style&index=0&id=972abc52&lang=css"
import "./ReportCaricamenti.vue?vue&type=style&index=1&id=972abc52&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-972abc52"]])

export default __exports__